declare namespace $ {

	export class $bog_ui_tooltip extends $bog_tooltip_plugin {
	}
	
}

//# sourceMappingURL=tooltip.view.tree.d.ts.map